import { Header } from "../ui/Header";
import { useState } from "react";
import { StippetsArea } from "../features/stippets/StippetsArea";
import { useLocalStorage } from "../hooks/useLocalStorage";
import { WorldsArea } from "../features/worlds/WorldsArea";
import styles from "./App.module.css";
import sectionStyles from "../styles/Section.module.css";

export default function App() {
  const [currentWorld, setCurrentWorld] = useState(null);
  const [stippetData, setStippetData] = useLocalStorage("stippets", []);
  const currentWorldData = stippetData.find(
    (world) => world.id === currentWorld,
  );
  const currentWorldName = currentWorldData ? currentWorldData.worldName : "";
  const currentWorldStippets = currentWorldData
    ? currentWorldData.stippets
    : [];

  function handleCreateNewStippet(newStippetObject) {
    setStippetData((setStippetData) => {
      const updatedStippetData = setStippetData.map((world) => {
        if (world.id === currentWorld) {
          return { ...world, stippets: [...world.stippets, newStippetObject] };
        }
        return world;
      });
      return updatedStippetData;
    });
  }

  function handleCreateNewWorld(newWorldObject) {
    setStippetData((prevWorlds) => [newWorldObject, ...prevWorlds]);
  }

  function handleSelectWorld(id) {
    setCurrentWorld(id);
  }

  function handleDeleteWorld(worldId) {
    setStippetData((prevWorlds) =>
      prevWorlds.filter((world) => world.id !== worldId)
    );
    setCurrentWorld((prevCurrent) =>
      prevCurrent === worldId ? null : prevCurrent
    );
  }

  return (
    <>
      <Header></Header>
      <main className={styles.app}>
        <section className={`${styles.panel} ${styles.panelWorlds}`}>
          <div className={sectionStyles.sectionHeader}>
            <div>
              <p className={sectionStyles.sectionKicker}>Worlds</p>
              <h2 className={sectionStyles.sectionTitle}>Your worlds</h2>
            </div>
          </div>
          <WorldsArea
            onSelectWorld={handleSelectWorld}
            onCreateWorld={handleCreateNewWorld}
            worlds={stippetData}
            currentWorld={currentWorld}
          />
        </section>
        <section className={styles.panel}>
          {currentWorld ? (
            <StippetsArea
              stippets={currentWorldStippets}
              onCreateStippet={handleCreateNewStippet}
              currentWorld={currentWorld}
              currentWorldName={currentWorldName}
              onDeleteWorld={handleDeleteWorld}
            />
          ) : (
            <div className={sectionStyles.emptyState}>
              <p className={sectionStyles.emptyTitle}>Pick a world to begin</p>
              <p className={sectionStyles.emptyBody}>
                Worlds are lightweight containers for your story stippets.
                Create one on the left, then start adding.
              </p>
            </div>
          )}
        </section>
      </main>
    </>
  );
}
